/* ============
 * Mutation types for the profile module
 * ============
 *
 * The mutation types that are available
 * on the profile module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({
  SET_USER: null,

  CREATE_USER: null,
  CREATE_USER_SUCCESS: null,
  CREATE_USER_FAIL: null,

  FETCH_ALL_USERS: null,
  FETCH_ALL_USERS_SUCCESS: null,
  FETCH_ALL_USERS_FAIL: null,

  UPDATE_USER: null,
  UPDATE_USER_SUCCESS: null,
  UPDATE_USER_FAIL: null,

  FETCH_USER: null,
  FETCH_USER_SUCCESS: null,
  FETCH_USER_FAIL: null,

  DELETE_USER: null,
  DELETE_USER_SUCCESS: null,
  DELETE_USER_FAIL: null,

  RESET_USER: null,

  CHANGE_PASSWORD: null,
  CHANGE_PASSWORD_SUCCESS: null,
  CHANGE_PASSWORD_FAIL: null,

  REQUEST_DEMO: null,
  REQUEST_DEMO_SUCCESS: null,
  REQUEST_DEMO_FAIL: null


});
